module.exports = __webpack_public_path__ + "static/img/zxpxjyzh.f4b373aa.jpg";